import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_URL;
const TOKEN_URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_TOKEN;

const getAllClients = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/clients', options);
};

const getAllPlans = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/plans', options);
};

const getTemplateById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/templates/code/' + dataClientId, options);
};

const createClient = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/clients', dataClient, options);
};

const updateTemplate = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/templates/' + dataClientId, dataClient, options);
};

const deleteTemplate = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/templates/' + dataClientId, options);
};

const getSuscripcionPlan = dataSuscripcionId => {
  //let {NERTHUS, options} = ConfigAxios();
  let options = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': TOKEN_URL_GET_PLAN
    }
  };
  return axios.get(URL_GET_PLAN + dataSuscripcionId, options);
};

const uploadZipTemplate = (zipTemplate) => {
  let {NERTHUS, options} = ConfigAxios();
  let auth = options.headers.Authorization;
  let optionsZip = {
    headers: {
        'Authorization': auth
        
    }}
  return axios.post(NERTHUS + '/templates/uploadTemplate', zipTemplate, optionsZip);
};

const uploadImagesTemplate = (idTemplate, zipTemplate) => {
  let {NERTHUS, options} = ConfigAxios();
  let auth = options.headers.Authorization;
  let optionsZip = {
    headers: {
        'Authorization': auth
        
    }}
  return axios.post(NERTHUS + '/templates/upImagesTemplates/'+ idTemplate, zipTemplate, optionsZip);
};

const ClientCrudService = {
  getAllClients,
  getTemplateById,
  getAllPlans,
  createClient,
  updateTemplate,
  deleteTemplate,
  getSuscripcionPlan,
  uploadZipTemplate,
  uploadImagesTemplate
};

export default ClientCrudService;